import { gql } from "@apollo/client"

const GET_STAFF_SCHEDULE = gql`  
  query (
    $staffScheduleInput: StaffScheduleInput!, 
    $staffSchedulePage: Int!, 
    $staffSchedulePerPage: Int!,
  ) {
	  staffSchedule(input: $staffScheduleInput, page: $staffSchedulePage, first: $staffSchedulePerPage) {
      data {
        id
        booking_id
        booking_slot_id
        booking_slot_created_at
        starts_at
        ends_at
        group
        group_id
        lesson
        student
        student_photo
        teacher_comments
        teacher_comment_id
			  parent_comments
        parent_comment_id
        parent
        parent_mis_phone
			  parent_sb_phone
        slot_status
        attendance_status
        meeting_type
        meeting_type_code
        booked_by_user
        invitation_email_last_sent_date
        subject
      }
	  }
  }
`

export { GET_STAFF_SCHEDULE }